import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RootState} from "../../Redux";
import {Typography} from "@mui/material";
import {TextButton} from "../Button";
import {AccordionItem} from "./AccordionItem";
import React from "react";
import {makeStyles} from "tss-react/mui";
import {Theme} from "@mui/material/styles";

const useStyles = makeStyles()((theme: Theme) => ({
    accordionContent: {
        flex: 1,
    },
    text: {
        fontSize: theme.typography.pxToRem(14),
    },
}))

export default function StationInfo() {
    const { t } = useTranslation()
    const { classes } = useStyles()

    const stationInfo = useSelector((state: RootState) => state.checkIn.checkIn?.station)
    const address = useSelector((state: RootState) => state.checkIn.checkIn?.station?.address)
    const stationMapLink = useSelector((state: RootState) => state.ui.settings?.booking?.options?.mapLink ?? null)

    const openGoogleMaps = () => {
        const coordinates = stationInfo?.coordinates

        if (stationMapLink) {
            if (stationMapLink.startsWith('http://') || stationMapLink.startsWith('https://')) {
                window.open(stationMapLink, '_blank')
            } else {
                window.open('https://maps.app.goo.gl/' + stationMapLink, '_blank')
            }
        } else if (coordinates?.latitude && coordinates?.longitude) {
            window.open(`https://www.google.com/maps?q=${coordinates?.latitude},${coordinates?.longitude}`, '_blank')
        } else if (address) {
            window.open(`https://www.google.com/maps?q=${address.line1},${address.zipCode},${address.city}`, '_blank')
        }
    }

    const renderStationInfo = () => (
        <div className={classes.accordionContent}>
            <Typography className={classes.text}>
                {stationInfo?.address?.line1}
            </Typography>
            <Typography className={classes.text}>
                {stationInfo?.address ? `${stationInfo.address?.zipCode} ${stationInfo.address?.city}` : ''}
            </Typography>
            <TextButton onClick={openGoogleMaps}>
                {t('serviceCardContainer.showOnMap')}
            </TextButton>
        </div>
    )

    return (
        <AccordionItem
            heading={t('serviceCardContainer.office')}
            subHeading={stationInfo?.name}
            content={renderStationInfo()}
        />
    );
}
